import styled from "styled-components";

export const Title = styled.h2`
    margin-top: 1.5rem;
    margin-bottom: 0;
`;